import { ReactNode } from "react";
import CustomMaterialUpload from "./CustomMaterialUpload";
import CreativeUploadCard from "./CreativeUploadCard";
import DesignTipsCard from "./DesignTipsCard";
import CreativeCalendarOverview from "../creative-upload/CreativeCalendarOverview";
import { Creative, Location } from "../../types";

interface ContentStepLayoutProps {
  customMaterialLocations: Location[];
  locationCreatives: Record<string, Creative[]>;
  mediaOwnerCreatives?: Record<string, Creative[]>;
  onLocationFileChange: (locationName: string, e: React.ChangeEvent<HTMLInputElement>, day?: number) => void;
  onRemoveLocationCreative: (locationName: string, index: number) => void;
  onUpdateLocationCreativeDays?: (locationName: string, creativeIndex: number, days: number[]) => void;
  isUploading: boolean;
  uploadProgress?: number;
  children: ReactNode;
  selectedLocations?: Location[];
}

const ContentStepLayout = ({
  customMaterialLocations,
  locationCreatives,
  mediaOwnerCreatives = {},
  onLocationFileChange,
  onRemoveLocationCreative,
  onUpdateLocationCreativeDays,
  isUploading,
  uploadProgress,
  children,
  selectedLocations = []
}: ContentStepLayoutProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-6">
        {/* Calendar Overview - shows schedule visualization */}
        <CreativeCalendarOverview 
          locationCreatives={locationCreatives}
          mediaOwnerCreatives={mediaOwnerCreatives}
          selectedLocations={selectedLocations.length > 0 ? selectedLocations : customMaterialLocations}
        />

        {/* Custom Material Upload for special dimension locations */}
        {customMaterialLocations.length > 0 && (
          <CustomMaterialUpload 
            locations={customMaterialLocations}
            locationCreatives={locationCreatives}
            onLocationFileChange={onLocationFileChange}
            onRemoveLocationCreative={onRemoveLocationCreative}
            onUpdateLocationCreativeDays={onUpdateLocationCreativeDays}
            isUploading={isUploading}
            uploadProgress={uploadProgress}
          />
        )}

        {/* Creative Upload */}
        {children}
      </div>
      
      {/* Design Tips */}
      <div className="lg:col-span-1">
        <DesignTipsCard />
      </div>
    </div>
  );
};

export default ContentStepLayout;
